<template>
  <div class="shop">
    <!-- <div class="title_box">
      <h2 class="title_left">{{items.title}}</h2>
      <router-link class="title_right" tag="span" to="/activity?come=wall">更多</router-link>
    </div> -->
    <section class="title_box" v-if="$store.state.common.theme!=3">
      <h2 class="title_left">{{items.title}}</h2>
      <router-link tag="span" class="title_right" to="/activity?come=wall">更多</router-link>
    </section>
    <section v-if="$store.state.common.theme==3" class="title_box_theme3">
      <h2 class="title_left">{{items.title}}</h2>
      <router-link tag="span" class="title_right" to="/activity?come=wall">更多</router-link>
    </section>
    <!-- 一行3个 -->
    <ul class="shop_list_theme3" v-if="$store.state.common.theme==3">
      <!--  :to="'/companyDetail/'+item.companyId" -->
      <div
        tag="li"
        @click="toCompanyDetail(item.companyId)"
       
        :class="index==2?'last_item':'list_item'"
        v-for="(item,index) in newList"
        :key="index"
      >
        <img class="list_item_icon" :src="item.logo?item.logo:require(`../../../assets/images/img_company_wall.jpg`)" alt />
        <div class="list_item_title"><p>{{item.companyName}}</p></div>
    </div>
    </ul>
    <!-- 滚动8个-->
    <div class="scroll" ref="gun" v-else-if="items.listStyle == 1">
      <ul ref="nav" class="shop_list shop_list_scroll">
        <div
          ref="personTab"
          tag="li"
          @click="toCompanyDetail(item.companyId)"
          class="list_item list_item_scroll"
          v-for="(item,index) in newList"
          :key="index"
        >
          <div class="img_box">
            <img :src="item.logo?item.logo:require(`../../../assets/images/img_company_wall.jpg`)"/>
          </div>
          <p class="list_item_p">{{item.companyName}}</p>
          <p class="list_item_p list_item_address">{{item.address}}</p>
        </div>
      </ul>
    </div>
    <!-- 一行2个 -->
    <ul class="shop_list" v-else-if="items.listStyle == 0">
      <div
        tag="li"
        @click="toCompanyDetail(item.companyId)"
        class="list_item list_item_two"
        v-for="(item,index) in newList"
        :key="index"
      >
        <div class="img_box">
            <img :src="item.logo?item.logo:require(`../../../assets/images/img_company_wall.jpg`)"/>
          </div>
        <p class="list_item_p">{{item.companyName}}</p>
          <p class="list_item_p list_item_address">{{item.address}}</p>
        </div>
    </ul>
  </div>
</template>

<script>
import BScroll from "better-scroll";
import { mapState, mapActions } from "vuex";
export default {
  name: "indexActivity",
  props: {
    list: Array,
    items: Object
  },
  data() {
    return {};
  },
  computed: {
     ...mapState({
      common: state => state.common
    }),
    newList() {
      let newList = this.list;
      if(this.$store.state.common.theme!=3){
        if (this.items.listStyle === 1) {
          return newList.slice(0, 8);
        } else if (this.items.listStyle === 2) {
          return newList.slice(0, 6);
        } else if (this.items.listStyle === 0) {
          return newList.slice(0, 4);
        } else {
          return [];
        }
      }else{
        return newList.slice(0, 3);
      }
    }
  },
  created() {
    if (this.items.listStyle == 2) {
      setTimeout(() => {
        this.tabScroll();
      }, 2000);
    }
  },
  methods: {
    tabScroll() {
      if (!this.scroll) {
        this.$refs.nav.style.width =
          this.$refs.personTab[0].$el.clientWidth *
            this.$refs.personTab.length +
          "px";
        this.scroll = new BScroll(this.$refs.gun, {
          startX: 0,
          click: true,
          scrollX: true,
          // 忽略竖直方向的滚动
          scrollY: false,
          eventPassthrough: "vertical"
        });
      } else {
        this.scroll.refresh();
      }
    },
     // 企业墙详情
    toCompanyDetail(id) {
      if(this.common.userId){
        this.$router.push(`/companyDetail/${id}`);
      }else{
        this.$router.push({
          path:'/login',
          query:{
            Rurl:`/companyDetail/${id}`
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.shop {
  margin-top:10px;
  padding: .14rem 0.2rem 0;
  .title_box {
    .flex();
    justify-content: space-between;
    align-items: center;
    height: 1rem;
    .title_left {
      .flex();
      flex-direction: row;
      font-size: 0.36rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .title_right {
      font-size: 0.26rem;
      color: #666;
    }
  }
  .title_box_theme3 {
    .flex();
    justify-content: space-between;
    align-items: center;
    height: .44rem;
    margin-bottom: 0.26rem;
    .title_left {
      .flex();
      flex-direction: row;
      font-size:40px;
      line-height: 44px;
      font-weight: bold;
      color: #000000;
      padding-right: 0.56rem;
      background: url("../../../assets/images/icon_hot_3.png") right center
        no-repeat;
      background-size: 44px 44px;
    }
    .title_right {
      font-size: 0.26rem;
      color: #c9a779;
    }
  }
}
.shop_list {
  .flex();
  justify-content: space-between;
  .list_item {
    .flex();
    flex-direction: column;
    width: 260px;
    .border();
    margin-right: 20px;
    background-color: #ffffff;
    overflow: hidden;
    box-sizing:border-box;
    margin-bottom: 20px;
    box-shadow:0px 4px 12px 0px rgba(0,0,0,0.04);
    .img_box{
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items: center;
      img {
        display: block;
        width: 160px;
        height: 160px;
        padding:40px 0 28px;
        object-fit: contain;
        margin:0 auto;
      }
    }
    p {
      margin-top: 20px;
      margin-left: 20px;
      width: 240px;
      .fontSize(14px);
      font-weight: bold;
      color: @color3;
      line-height: 40px;
      text-align: left;
      .textOver(240px);
    }
  }
  .list_item_two {
    width: 344px;
    height:344px;
    .border();
    .flex();
    flex-direction:column;
    margin:0 0 20px 0;
    text-align: center;
    align-items: center;
    .img_box{
      width: 100%;
      height: 228px;
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items: center;
      border:0;
      img {
        display: block;
        width: 160px;
        height: 160px;
        padding:40px 0 28px;
        margin:0 auto;
      }
    }
    p {
      margin:0;
      text-align:center;
      .textOver(300px);
    }
    .list_item_address{
      font-size:24px;
      color:rgba(153,153,153,1);
      line-height:34px;
      margin:8px 20px 0 20px;
      font-weight:normal;
    }
  }
}

.shop_list_theme3{
  .flex();
  border-radius: 10px;
  flex-direction: row;
  background-color: #ffffff;
  padding-bottom: 20px;
  padding-top: 20px;
  .list_item{
    .flex();
    margin-right: 30px;
    margin-left: 10px;
    width: 200px;
    flex-direction: column;
   
  }
  .last_item{
    margin-right: 0;
    margin-left: 10px;
    .flex();
    width: 200px;
    flex-direction: column;
   
    
  }
  .list_item_icon{
    width: 200px;
    height: 200px;
  }
  .list_item_title{
    width: 200px;
    .flex();
    margin-top: 10px;
    flex-direction: row;
    justify-content: center;
    
    p{
        .fontSize(13px);
        font-weight: bold;
        color:#000000;
        line-height: 34px;
    
        .textOver(200px);
    }
  }

}
.shop_list_scroll {
  flex-wrap: nowrap;
  justify-content: flex-start;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom:0;
  .list_item {
    flex-shrink: 0;
    width: 280px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    overflow: hidden;
    margin-right: 20px;
    .border();
    box-sizing:border-box;
    box-shadow:0px 4px 12px 0px rgba(0,0,0,0.04);
    .img_box{
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items: center;
      img {
        display: block;
        width: 160px;
        height: 160px;
        padding:40px 0 28px;
        margin:0 auto;
      }
    }
    .list_item_p {
      margin:0 20px;
      .fontSize(12px);
      font-weight: bold;
      color: @color3;
      line-height: 34px;
      text-align: left;
      width:240px;
      .textOver(240px);
    }
    .list_item_address{
      font-size:24px;
      color:rgba(153,153,153,1);
      line-height:34px;
      margin:8px 20px 34px 20px;
      font-weight:normal;
    }
  }
}
</style>
